import axios from 'axios';
import store from './../store'

const baseUrl = 'https://restokuapi.online';
// let baseUrl = 'http://localhost:9001';

if (store.state.settings.toko.id == 19217) {
    baseUrl = 'https://nyamplungan.restoku.id';
}

const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

export const get = (url) => {
    // const id_toko = store.state.settings.user.id_toko || -1

    return axios.get(baseUrl + url)
        .then(response => {
            return response.data;
        });
}

export const post = (url, data) => {
    let param = {}
    Object.keys(data).forEach(item => {
        param[camelToSnakeCase(item)] = data[item];
    })

    return axios.post(baseUrl + url, param)
        .then(response => {
            return response.data;
        });
}

export const postJson = (url, data) => {
    let origin = baseUrl + url
    if (url.indexOf('https') > -1) {
        origin = url;
    }
    return axios.post(origin, JSON.stringify(data))
        .then(response => {
            return response.data;
        });
}


// WEBPACK FOOTER //
// ./src/api/Api.js